

import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

export default function Nav() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();

  // Route change hone par menu close karo
  useEffect(() => {
    setIsOpen(false);
    setDropdownOpen(false);
  }, [location]);

  // Scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Body scroll lock when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About" },
    { path: "/portfoliopage", label: "Portfolio" },
    { path: "/contact", label: "Contact" },
  ];

  const serviceLinks = [
    { path: "/services/software-development", label: "Software Development" },
    { path: "/services/web-development", label: "Web Development" },
    { path: "/services/mobile-app-development", label: "Mobile App Development" },
    { path: "/services/ui-ux-design", label: "UI/UX Design" },
    { path: "/services/seo", label: "SEO" },
    { path: "/services/social-media-marketing", label: "Social Media Marketing" },
    { path: "/services/google-ads-ppc", label: "Google Ads / PPC" },
    { path: "/services/email-marketing", label: "Email Marketing" },
    { path: "/services/graphic-design", label: "Graphic Design" },
    { path: "/services/cloud-services", label: "Cloud Services" },
    { path: "/services/ai-ml-solutions", label: "AI & ML Solutions" },
    { path: "/services/cybersecurity", label: "Cybersecurity" },
    { path: "/services/it-consulting", label: "IT Consulting" },
    { path: "/services/video-animation", label: "Video & Animation" },
  ];

  return (
    <>
      {/* ========== HEADER ========== */}
      <header
        id="header"
        className={`header fixed-top ${scrolled ? "header-scrolled" : ""}`}
        style={{
          zIndex: 1234,
          backgroundColor: "white",
          boxShadow: scrolled ? "0 2px 20px rgba(0,0,0,0.1)" : "none",
          transition: "all 0.3s ease",
        }}
      >
        <div className="container-fluid container-xl d-flex align-items-center justify-content-between">

          {/* ========== LOGO ========== */}
          <Link
            to="/"
            className="logo d-flex align-items-center"
            style={{ textDecoration: "none" }}
          >
            <img src="/img/logo/sdtechlogo.png" alt="SDtech Solutions Logo" style={{ height: "40px" }} /> <br />
            <span style={{ fontWeight: "bold", fontSize: "1.4rem", color: "#007bff", letterSpacing: "1px" }}>
              SDtech
            </span>
            <span style={{ fontWeight: "600", fontSize: "1.4rem", color: "#333", marginLeft: "2px" }}>
              Solutions
            </span>
          </Link>

          {/* ========== DESKTOP NAVBAR ========== */}
          <nav className="desktop-nav">
            <ul>
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    className={`nav-link scrollto ${location.pathname === link.path ? "active" : ""}`}
                    to={link.path}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}

              {/* Services Dropdown */}
              <li
                className="dropdown"
                onMouseEnter={() => setDropdownOpen(true)}
                onMouseLeave={() => setDropdownOpen(false)}
              >
                <Link to="/services">
                  <span className={location.pathname.startsWith("/services") ? "active" : ""}>
                    Services
                  </span>
                  <i className="bi bi-chevron-down" />
                </Link>
                <ul>
                  {serviceLinks.map((link) => (
                    <li key={link.path}>
                      <Link to={link.path}>{link.label}</Link>
                    </li>
                  ))}
                </ul>
              </li>

              {/* ✅ Get a Quote Button */}
              <li>
                <Link className="getstarted scrollto" to="/get-quote">
                  Get a Quote
                </Link>
              </li>
            </ul>
          </nav>

          {/* ========== HAMBURGER ICON ========== */}
          <div className="mobile-nav-toggle" onClick={() => setIsOpen(!isOpen)}>
            <i className={`bi ${isOpen ? "bi-x" : "bi-list"}`} />
          </div>
        </div>
      </header>

      {/* ========== MOBILE NAV OVERLAY ========== */}
      <div className={`mobile-overlay ${isOpen ? "active" : ""}`} onClick={() => setIsOpen(false)} />

      {/* ========== MOBILE NAVBAR ========== */}
      <div className={`mobile-nav ${isOpen ? "active" : ""}`}>
        <div className="mobile-nav-close" onClick={() => setIsOpen(false)}>
          <i className="bi bi-x-lg" />
        </div>

        <div className="mobile-nav-logo">
          <span style={{ color: "#007bff", fontWeight: "800", fontSize: "1.3rem" }}>SDtech</span>
          <span style={{ color: "#333", fontWeight: "600", fontSize: "1.3rem", marginLeft: "2px" }}>Solutions</span>
        </div>

        <ul className="mobile-nav-links">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link to={link.path} className={location.pathname === link.path ? "active" : ""}>
                <i className={`bi ${
                  link.path === "/" ? "bi-house" :
                  link.path === "/about" ? "bi-person" :
                  link.path === "/portfoliopage" ? "bi-briefcase" :
                  "bi-envelope"
                }`} />
                {link.label}
              </Link>
            </li>
          ))}

          {/* Mobile Services Dropdown */}
          <li className="mobile-dropdown">
            <div
              className={`mobile-dropdown-toggle ${location.pathname.startsWith("/services") ? "active" : ""}`}
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              <i className="bi bi-gear" />
              <span>Services</span>
              <i className={`bi ${dropdownOpen ? "bi-chevron-up" : "bi-chevron-down"}`} style={{ marginLeft: "auto", fontSize: "12px" }} />
            </div>

            <ul className={`mobile-dropdown-menu ${dropdownOpen ? "active" : ""}`}>
              {serviceLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className={location.pathname === link.path ? "active" : ""}>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </li>

          {/* Get Quote Button */}
          <li>
            <Link to="/get-quote" className="mobile-get-quote">
              Get a Quote <i className="bi bi-arrow-right ms-2" />
            </Link>
          </li>
        </ul>

        <div className="mobile-nav-contact">
          <a href="tel:+917000191398">
            <i className="bi bi-telephone" /> +91 7000191398
          </a>
          <a href="mailto:info@sdtechsolutions.com">
            <i className="bi bi-envelope" /> info@sdtechsolutions.com
          </a>
        </div>

        <div className="mobile-nav-social">
          <a href="https://facebook.com/" target="_blank" rel="noreferrer">
            <i className="bi bi-facebook" />
          </a>
          <a href="https://instagram.com/" target="_blank" rel="noreferrer">
            <i className="bi bi-instagram" />
          </a>
          <a href="https://linkedin.com/" target="_blank" rel="noreferrer">
            <i className="bi bi-linkedin" />
          </a>
          <a href="https://twitter.com/" target="_blank" rel="noreferrer">
            <i className="bi bi-twitter" />
          </a>
        </div>
      </div>
            
            <style>{`
              
.desktop-nav {
  display: flex;
}

.desktop-nav ul {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
}

.desktop-nav li {
  position: relative;
}

.desktop-nav a,
.desktop-nav a:focus {
  display: flex;
  align-items: center;
  padding: 10px 18px;
  font-family: var(--font-primary);
  font-size: 15px;
  font-weight: 600;
  color: var(--dark);
  white-space: nowrap;
  transition: all 0.3s ease;
  text-decoration: none;
}

.desktop-nav a:hover,
.desktop-nav .active,
.desktop-nav li:hover > a {
  color: var(--primary);
}

/* Desktop Dropdown */
.desktop-nav .dropdown ul {
  display: block;
  position: absolute;
  left: 0;
  top: calc(100% + 15px);
  margin: 0;
  padding: 10px 0;
  background: var(--white);
  border-radius: 6px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid #e8e8e8;
  min-width: 260px;
  z-index: 99;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.desktop-nav .dropdown ul li {
  width: 100%;
}

.desktop-nav .dropdown ul a {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-color);
}

.desktop-nav .dropdown ul a:hover {
  color: var(--primary);
  background: var(--light);
}

.desktop-nav .dropdown:hover > ul {
  opacity: 1;
  visibility: visible;
  top: 100%;
}

.desktop-nav .getstarted {
  background: var(--primary);
  color: var(--white) !important;
  padding: 10px 25px !important;
  border-radius: 50px;
  font-weight: 600;
  margin-left: 15px;
  transition: all 0.3s ease;
}

.desktop-nav .getstarted:hover {
  background: var(--primary-dark);
  color: var(--white) !important;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 123, 255, 0.3);
}

/* Hamburger Icon */
.mobile-nav-toggle {
  display: none;
  font-size: 28px;
  cursor: pointer;
  color: var(--dark);
  padding: 5px;
  z-index: 1235;
}

.mobile-nav-toggle i {
  transition: all 0.3s ease;
}

/* Mobile Overlay */
.mobile-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1234;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.mobile-overlay.active {
  opacity: 1;
  visibility: visible;
}

/* Mobile Nav Panel */
.mobile-nav {
  position: fixed;
  top: 0;
  right: -320px;
  width: 300px;
  height: 100vh;
  background: var(--white);
  z-index: 1235;
  overflow-y: auto;
  transition: right 0.3s ease;
  padding: 0;
  box-shadow: -5px 0 30px rgba(0, 0, 0, 0.15);
}

.mobile-nav.active {
  right: 0;
}

/* Mobile Nav Close */
.mobile-nav-close {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--light);
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  color: var(--dark);
  transition: all 0.3s ease;
  z-index: 10;
}

.mobile-nav-close:hover {
  background: var(--primary);
  color: var(--white);
}

/* Mobile Nav Logo */
.mobile-nav-logo {
  padding: 20px 20px 15px;
  border-bottom: 1px solid #f0f0f0;
}

/* Mobile Nav Links */
.mobile-nav-links {
  list-style: none;
  padding: 10px 0;
  margin: 0;
}

.mobile-nav-links > li > a,
.mobile-dropdown-toggle {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  font-family: var(--font-primary);
  font-size: 15px;
  font-weight: 600;
  color: var(--dark);
  text-decoration: none;
  transition: all 0.3s ease;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
}

.mobile-nav-links > li > a i,
.mobile-dropdown-toggle i:first-child {
  margin-right: 12px;
  font-size: 18px;
  color: var(--primary);
  width: 24px;
  text-align: center;
}

.mobile-nav-links > li > a:hover,
.mobile-nav-links > li > a.active,
.mobile-dropdown-toggle:hover,
.mobile-dropdown-toggle.active {
  color: var(--primary);
  background: #f0f7ff;
}

/* Mobile Dropdown */
.mobile-dropdown-menu {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease;
  background: #fafafa;
}

.mobile-dropdown-menu.active {
  max-height: 800px;
}

.mobile-dropdown-menu li a {
  display: block;
  padding: 10px 20px 10px 56px;
  font-size: 13px;
  font-weight: 500;
  color: #555;
  text-decoration: none;
  transition: all 0.3s ease;
  border-bottom: 1px solid #f0f0f0;
}

.mobile-dropdown-menu li a:hover,
.mobile-dropdown-menu li a.active {
  color: var(--primary);
  background: #e8f4fd;
  padding-left: 60px;
}

/* Mobile Get Quote Button */
.mobile-get-quote {
  display: block !important;
  text-align: center;
  margin: 15px 20px;
  padding: 14px 20px !important;
  background: var(--primary) !important;
  color: var(--white) !important;
  border-radius: 50px;
  font-weight: 700 !important;
  font-size: 15px !important;
  text-decoration: none;
  transition: all 0.3s ease;
}

.mobile-get-quote:hover {
  background: var(--primary-dark) !important;
  transform: translateY(-2px);
}

/* Mobile Contact Info */
.mobile-nav-contact {
  padding: 15px 20px;
  border-top: 1px solid #f0f0f0;
}

.mobile-nav-contact a {
  display: block;
  padding: 6px 0;
  font-size: 13px;
  color: #666;
  text-decoration: none;
  transition: 0.3s;
}

.mobile-nav-contact a:hover {
  color: var(--primary);
}

.mobile-nav-contact a i {
  margin-right: 8px;
  color: var(--primary);
}

/* Mobile Social Links */
.mobile-nav-social {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 15px 20px 25px;
  border-top: 1px solid #f0f0f0;
}

.mobile-nav-social a {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--light);
  color: var(--dark);
  font-size: 16px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.mobile-nav-social a:hover {
  background: var(--primary);
  color: var(--white);
  transform: translateY(-3px);
}

/* ============================================================
   RESPONSIVE — MOBILE BREAKPOINT
   ============================================================ */

@media (max-width: 991px) {
  /* Hide Desktop Nav */
  .desktop-nav {
    display: none;
  }

  /* Show Hamburger */
  .mobile-nav-toggle {
    display: block;
  }
}

@media (min-width: 992px) {
  /* Hide Mobile Nav on Desktop */
  .mobile-nav,
  .mobile-overlay,
  .mobile-nav-toggle {
    display: none !important;
  }
}

/* Small Mobile */
@media (max-width: 400px) {
  .mobile-nav {
    width: 100%;
    right: -100%;
  }
}


            `}</style>

    </>
  );
}